import { z } from 'zod'
import { residenceObject } from '~/packages/general/residence/residenceObject'
import { dateOrIsoString } from '~/prix/types/date'

export const propertyImprovementsObject = z.object({
  id: z.string().uuid(),
  residenceId: z.string().uuid().nullish(),
  residence: residenceObject.nullish(),
  improvementType: z.string().max(32).nullish(),
  quantity: z.number().int().nullish(),
  description: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  clientId: z.number().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  sourceFilter: z.string().nullish(),
})

export const propertyImprovementsUpsertInputObject = z.object({
  id: z.string().uuid().nullish(),
  residenceId: z.string().uuid().nullish(),
  improvementType: z.string().max(32).nullish(),
  quantity: z.number().int().nullish(),
  description: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
})

export type PropertyImprovementsType = z.infer<typeof propertyImprovementsObject>
export type PropertyImprovementsUpsertInput = z.infer<typeof propertyImprovementsUpsertInputObject>
